var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.getters['Loader/scanning'])?_c('v-overlay',{attrs:{"z-index":"10","color":"#000000","opacity":".6"}},[_c('v-card',{staticClass:"mx-auto",attrs:{"flat":"","rounded":""}},[_c('div',{staticClass:"scan"},[_c('div',{staticClass:"fingerprint"}),_c('h3',[_vm._v("Scanning...")])])])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }